module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "approval-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body top-button-bar"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        return _vm.getApprovalData(false)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isLocalAgencyUser || _vm.globals.isLeadAgencyUser || _vm.globals.isAdminUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.isSelectedCheckOnCurrentPage
    },
    on: {
      "click": function($event) {
        _vm.getApprovalData(false, function () { return (_vm.showShopperProposalModal = true); })
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("person_add")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.globals.isAgencyUser || _vm.globals.isLeadAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.isSelectedCheckOnCurrentPage || !_vm.selectedCheck.ShopperProposals
    },
    on: {
      "click": function($event) {
        _vm.getApprovalData(false, function () { return (_vm.toggleShopperApprovalModal()); })
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment_turned_in")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.globals.isAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showCarModelManagement = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("drive_eta")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0003) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.getApprovalData(false), _vm.globals.$emit('showApprovalWaveStatus', _vm.selectedCheck)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("insert_chart")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0004) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showExportDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0048) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showMap = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("place")]), _vm._v(" "), _c('br'), _vm._v("\n          Map\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0005
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0006))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage === 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0007))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage === pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage === _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0008))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "approvalTotalElementsCounter"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.checkCount) + "\n            ")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "approvalTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0009))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    attrs: {
      "id": "approvalMainTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0011) + "\n                "), (_vm.sortField == 'SurveyInstanceId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceInfo')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0073) + "\n                "), (_vm.sortField == 'SurveyInstanceInfo' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceInfo' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('WaveName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0013) + "\n                "), (_vm.sortField == 'WaveName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'WaveName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationStoreId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0014) + "\n                "), (_vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0015) + "\n                "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationCity')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0016) + "\n                "), (_vm.sortField == 'LocationCity' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationCity' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationCountry')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0017) + "\n                "), (_vm.sortField == 'LocationCountry' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationCountry' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('DealerGroup')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0018) + "\n                "), (_vm.sortField == 'DealerGroup' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'DealerGroup' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('Brand')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0019) + "\n                "), (_vm.sortField == 'Brand' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Brand' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('UTCLastUpdatedAt')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0020) + "\n                "), (_vm.sortField == 'UTCLastUpdatedAt' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'UTCLastUpdatedAt' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0021) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0022) + " (" + _vm._s(_vm.lang.SA0023) + ")\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0024) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0025) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0026) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "2.5%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0027) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0028) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0029) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0030) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0031) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SA0032) + "\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center unsortable-column-header",
    staticStyle: {
      "width": "3.5%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SAM002) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceId),
      expression: "filterStrings.SurveyInstanceId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceInfo),
      expression: "filterStrings.SurveyInstanceInfo"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceInfo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceInfo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.WaveName),
      expression: "filterStrings.WaveName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.WaveName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "WaveName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStoreId),
      expression: "filterStrings.LocationStoreId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationName),
      expression: "filterStrings.LocationName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.LocationName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCity),
      expression: "filterStrings.LocationCity"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCity)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.DealerGroup),
      expression: "filterStrings.DealerGroup"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.DealerGroup)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "DealerGroup", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Brand),
      expression: "filterStrings.Brand"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.Brand)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Brand", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar",
    attrs: {
      "id": "inputFilterLastUpdateAtContainer"
    },
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputFilterLastUpdateAt')
      }
    }
  }, [_c('input', {
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "text",
      "id": "inputFilterLastUpdateAt",
      "placeholder": _vm.lang.SA0033
    }
  }), _vm._v(" "), (_vm.lastUpdateAtFilterContent) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputFilterLastUpdateAtContainer",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lastUpdateAtFilterContent))]) : _vm._e()], 1)]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "3%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ShopperId),
      expression: "filterStrings.ShopperId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.ShopperId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ShopperId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.DisplayName),
      expression: "filterStrings.DisplayName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.DisplayName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "DisplayName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "3%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Gender),
      expression: "filterStrings.Gender"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.Gender)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Gender", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Distance),
      expression: "filterStrings.Distance"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.Distance)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Distance", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Occupation),
      expression: "filterStrings.Occupation"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.Occupation)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Occupation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "2.5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.CarModelName),
      expression: "filterStrings.CarModelName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.CarModelName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "CarModelName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.CarSegmentName),
      expression: "filterStrings.CarSegmentName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.CarSegmentName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "CarSegmentName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ShopperCar),
      expression: "filterStrings.ShopperCar"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.ShopperCar)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ShopperCar", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "3%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.CarMatch),
      expression: "filterStrings.CarMatch"
    }],
    staticClass: "form-control text-center nopadding",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterStrings, "CarMatch", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0034))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '+'
    }
  }, [_vm._v("+ " + _vm._s(_vm.lang.SA0035))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '='
    }
  }, [_vm._v("= " + _vm._s(_vm.lang.SA0036))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '-'
    }
  }, [_vm._v("- " + _vm._s(_vm.lang.SA0037))])])])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ApprovedByLeadAgency),
      expression: "filterStrings.ApprovedByLeadAgency"
    }],
    staticClass: "form-control text-center nopadding",
    class: {
      'option-green': _vm.filterStrings.ApprovedByLeadAgency === 'Approved',
      'option-red': _vm.filterStrings.ApprovedByLeadAgency === 'Rejected',
      'option-yellow': _vm.filterStrings.ApprovedByLeadAgency === 'Open',
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterStrings, "ApprovedByLeadAgency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      }]
    }
  }, [_c('option', {
    staticClass: "option-white",
    domProps: {
      "value": ''
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0034) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-white",
    domProps: {
      "value": 'None'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0038) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-green",
    domProps: {
      "value": 'Approved'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0039) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-yellow",
    domProps: {
      "value": 'Open'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0040) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-red",
    domProps: {
      "value": 'Rejected'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0041) + "\n                  ")])])])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "4%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ApprovedByMainEntity),
      expression: "filterStrings.ApprovedByMainEntity"
    }],
    staticClass: "form-control text-center nopadding",
    class: {
      'option-green': _vm.filterStrings.ApprovedByMainEntity === 'Approved',
      'option-red': _vm.filterStrings.ApprovedByMainEntity === 'Rejected',
      'option-yellow': _vm.filterStrings.ApprovedByMainEntity === 'Open',
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterStrings, "ApprovedByMainEntity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      }]
    }
  }, [_c('option', {
    staticClass: "option-white",
    domProps: {
      "value": ''
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0034) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-white",
    domProps: {
      "value": 'None'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0038) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-green",
    domProps: {
      "value": 'Approved'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0039) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-yellow",
    domProps: {
      "value": 'Open'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0040) + "\n                  ")]), _vm._v(" "), _c('option', {
    staticClass: "option-red",
    domProps: {
      "value": 'Rejected'
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SA0041) + "\n                  ")])])])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "3.5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.FeedPostCount),
      expression: "filterStrings.FeedPostCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "number"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterStrings, "FeedPostCount", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        (_vm.selectedPage = 1), _vm.getApprovalData(false)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0034))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0054))])])])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, [_vm._l((_vm.approvalData), function(check) {
    return [_c('tr', {
      key: check.SurveyInstanceGuid,
      class: {
        info: _vm.isCheckSelected(check.SurveyInstanceId)
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedCheck = check;
          _vm.selectCheck(check.SurveyInstanceId, $event)
        }
      }
    }, [_c('td', {
      staticClass: "wave-state-indicator",
      class: {
        'state-yellow': check.AudiStatus === 'WaveStarted',
        'state-orange': check.AudiStatus === 'WaveOneHalfPassed',
        'state-red': check.AudiStatus === 'WaveTwoThirdsPassed' || check.AudiStatus === 'ActionRequired',
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "4%"
      }
    }, [_vm._v(_vm._s(check.SurveyInstanceId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v(_vm._s(check.SurveyInstanceInfo))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      },
      attrs: {
        "id": ("approvalWaveNameTableData" + (check.SurveyInstanceGuid))
      }
    }, [_vm._v("\n                " + _vm._s(check.WaveName) + "\n                "), _c('br'), _vm._v(" "), (check.CarModelDistribution) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("info_outline")]) : _vm._e(), _vm._v(" "), (check.IsLeadAgencyPlus) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("add_box")]) : _vm._e()]), _vm._v(" "), (check.CarModelDistribution || check.CompetitorCarModelDistribution) ? _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("approvalWaveNameTableData" + (check.SurveyInstanceGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [(check.CarModelDistribution) ? [_c('b', [_vm._v(_vm._s(_vm.lang.SA0045) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((check.CarModelDistribution), function(model) {
      return _c('span', {
        key: model.CarModelGuid
      }, [_vm._v("\n                    " + _vm._s(model.CarModelName) + " - " + _vm._s(model.Distribution * 100) + "%\n                    "), _c('br')])
    })] : _vm._e(), _vm._v(" "), (check.CarModelDistribution && check.CompetitorCarModelDistribution) ? [_c('br')] : _vm._e(), _vm._v(" "), (check.CompetitorCarModelDistribution) ? [_c('b', [_vm._v(_vm._s(_vm.lang.SA0046) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((check.CompetitorCarModelDistribution), function(model) {
      return _c('span', {
        key: model.CompetitorCarModelGuid
      }, [_vm._v(" " + _vm._s(model.CompetitorCarBrand) + "\n                    " + _vm._s(model.CompetitorCarModel) + " -\n                    " + _vm._s(model.Distribution * 100) + "%\n                    "), _c('br')])
    })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(check.LocationStoreId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(check.LocationName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(check.LocationCity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "4%"
      }
    }, [_vm._v(_vm._s(check.LocationCountry))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(check.DealerGroup))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "4%"
      }
    }, [_vm._v(_vm._s(check.Brand))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      },
      attrs: {
        "id": ("approvalDateDiffTableData" + (check.SurveyInstanceGuid))
      }
    }, [(check.LastUpdatedAt) ? _c('span', [_vm._v("\n                  " + _vm._s(check.LastUpdatedAt) + " "), _c('br'), _vm._v(" "), (check.LastUpdatedColumn) ? _c('span', [_vm._v(_vm._s(_vm.lang.SA0052) + " " + _vm._s(check.LastUpdatedColumn) + " "), _c('br')]) : _vm._e(), _vm._v("\n                  " + _vm._s(_vm.lang.SA0053) + " " + _vm._s(check.SurveyInstanceStatusId) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("approvalDateDiffTableData" + (check.SurveyInstanceGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(check.UTCLastUpdatedAt))]), _vm._v(" "), _c('td', {
      staticClass: "nested-table-container",
      staticStyle: {
        "width": "50%"
      }
    }, [(check.ShopperProposals) ? [_c('table', {
      staticClass: "nested-table"
    }, _vm._l((check.ShopperProposals), function(proposal) {
      return _c('tr', {
        key: proposal.ShopperProposalGuid
      }, [_c('td', {
        staticStyle: {
          "width": "6%"
        }
      }, [_vm._v(_vm._s(proposal.ShopperId))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "14%"
        }
      }, [_vm._v(_vm._s(proposal.DisplayName))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "6%"
        }
      }, [_vm._v(_vm._s(proposal.Gender))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "10%"
        }
      }, [(typeof proposal.Distance === 'number') ? _c('span', [_vm._v(_vm._s(proposal.Distance) + " km")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "14%"
        }
      }, [_vm._v(_vm._s(proposal.Occupation))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "5%"
        }
      }, [_vm._v(_vm._s(proposal.CarModelName))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "8%"
        }
      }, [_vm._v("\n                        " + _vm._s(proposal.CarSegmentName) + "\n                      ")]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "8%"
        }
      }, [_vm._v(_vm._s(proposal.ShopperCar))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "6%"
        }
      }, [_vm._v(_vm._s(proposal.CarMatch))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "8%",
          "padding": "6px 0 0 0"
        }
      }, [(proposal.AgencyApprovalStatus === 'Approved') ? _c('i', {
        staticClass: "material-icons md-24 nopadding text-green"
      }, [_vm._v("done")]) : (proposal.AgencyApprovalStatus === 'Rejected') ? _c('i', {
        staticClass: "material-icons md-24 nopadding text-red"
      }, [_vm._v("clear")]) : _c('i', {
        staticClass: "material-icons md-24 nopadding text-yellow"
      }, [_vm._v("lens")])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "8%",
          "padding": "6px 0 0 0"
        }
      }, [(proposal.MainEntityApprovalStatus === 'Approved') ? _c('i', {
        staticClass: "material-icons md-24 nopadding text-green"
      }, [_vm._v("done")]) : (proposal.MainEntityApprovalStatus === 'Rejected') ? _c('i', {
        staticClass: "material-icons md-24 nopadding text-red"
      }, [_vm._v("clear")]) : _c('i', {
        staticClass: "material-icons md-24 nopadding text-yellow"
      }, [_vm._v("lens")])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "7%",
          "padding": "6px 0 0 0"
        }
      }, [(proposal.FeedPostCount > 0) ? _c('i', {
        staticClass: "material-icons md-24"
      }, [_vm._v("forum")]) : _vm._e()])])
    }), 0)] : _vm._e()], 2)], 1)]
  })], 2)])])]), _vm._v(" "), (_vm.showShopperProposalModal) ? _c('ShopperProposalModal', {
    attrs: {
      "check": _vm.selectedCheck
    },
    on: {
      "modalClosed": function($event) {
        _vm.showShopperProposalModal = false
      },
      "dataUpdated": function($event) {
        return _vm.getApprovalData(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShopperApprovalModal) ? _c('ShopperApprovalModal', {
    ref: "ShopperApprovalModal",
    attrs: {
      "check": _vm.selectedCheck
    },
    on: {
      "modalClosed": function($event) {
        _vm.showShopperApprovalModal = false
      },
      "resetData": function($event) {
        return _vm.getApprovalData(false, _vm.$refs.ShopperApprovalModal.init)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShopperMultiApprovalModal) ? _c('ShopperMultiApprovalModal', {
    attrs: {
      "checks": _vm.selectedChecks
    },
    on: {
      "modalClosed": function($event) {
        _vm.showShopperMultiApprovalModal = false
      },
      "resetData": function($event) {
        return _vm.getApprovalData(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('CarModelManagement', {
    attrs: {
      "showModal": _vm.showCarModelManagement
    },
    on: {
      "modalClosed": function($event) {
        _vm.showCarModelManagement = false
      }
    }
  }), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "dialogId": 'ShopperApprovalExportApprovalConfirmation',
      "confirmationTitle": _vm.lang.SA0049,
      "yesButtonText": _vm.lang.SA0050,
      "noButtonText": _vm.lang.SA0051,
      "showDialog": _vm.showExportDialog
    },
    on: {
      "onYesConfirmation": _vm.exportApproval,
      "dialogClosed": function($event) {
        _vm.showExportDialog = false
      }
    }
  }), _vm._v(" "), _c('ApprovalWaveStatusModal'), _vm._v(" "), (_vm.showMap) ? _c('ShopperApprovalMap', {
    attrs: {
      "checkList": _vm.selectedChecks
    },
    on: {
      "close": function($event) {
        _vm.showMap = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4d1dada","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopperApproval/ShopperApproval.vue
// module id = 1725
// module chunks = 1